import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NoPortfolioDataComponent } from './no-portfolio-data/no-portfolio-data.component';
import { Portfolio360AuthGuard } from './guards/portfolio360.guard';
import { AccountDetailsComponent } from './components/client-account-details/client-account-details.component';
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { PortfolioPnlComponent } from './components/portfolio-pnl/portfolio-pnl.component';
import { ConnectedAccountsComponent } from './components/connected-accounts/connected-accounts.component';
import { MarketMantraComponent } from './components/market-mantra/market-mantra.component';

const routes: Routes = [
  {
    path: 'demo',
    loadChildren: () => import('./guest-login/pages/login/guest-login.module').then( m => m.GuestLoginPageModule)
  },
  {
    path: 'guest',
    loadChildren: () => import('./guest-login/tabs/guest-tabs.module').then( m => m.GuestTabsPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'login',
    canActivate: [ Portfolio360AuthGuard ],
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'client-portfolio-details/:id', 
    component: AccountDetailsComponent,
  },
  {        
    path: 'portfolio-analytics',
    component: AnalyticsComponent
  },
      {
        path: 'most-active-stock-index',
        loadChildren: () => import('./pages/most-active-stock-index/most-active-stock-index.module').then( m => m.MostActiveStockIndexPageModule)
      },
  {
    path: 'family-portfolio', 
    loadChildren: () => import('./components/family-portfolio/family-portfolio.module').then( m => m.FamilyPortfolioModule)
  },
  {
    path: 'not-found',
    component: NoPortfolioDataComponent
  },
  {
    path: 'research-reports',
    component: MarketMantraComponent
  },
  {
    path: 'connected-accounts',
    component: ConnectedAccountsComponent
  },
  {
    path: 'portfolio-pnl',
    component: PortfolioPnlComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }

  
  
   
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}

 
